// extracted by mini-css-extract-plugin
export default {"termContainer":"confirmOrder_termContainer__sdVAT","termDiv":"confirmOrder_termDiv__m1Wwg","termsLink":"confirmOrder_termsLink__meOrG"};